// Базовые типы обмена с сервером. Договор между сессиями: деньги ходят целым числом копеек,
// дробные величины (ставка, часы) — строкой, не числом с плавающей точкой
// (contracts/openapi/bark-core.v1.yaml, ПРАВИЛА.md раздел 3).

declare const KOPECKS_BRAND: unique symbol;

/**
 * Целые копейки. Брендированный number: обычное число в функцию про деньги не пролезает,
 * а значит рубли и копейки не перепутать на границе типов, а не в проде.
 */
export type Kopecks = number & { readonly [KOPECKS_BRAND]: true };

/** Единственная дверь в тип Kopecks: проверяет целость до того, как значение станет деньгами. */
export function kopecks(value: number): Kopecks {
  if (!Number.isSafeInteger(value)) {
    throw new Error(`копейки передаются целым числом, получено ${value}`);
  }
  return value as Kopecks;
}

declare const DECIMAL_BRAND: unique symbol;

/**
 * Десятичная строка вида «152.329749». Ставка dec(18,6) и часы dec(5,2) передаются строкой:
 * число с плавающей точкой потеряло бы копейку на дробной ставке.
 */
export type DecimalString = string & { readonly [DECIMAL_BRAND]: true };

const DECIMAL_PATTERN = /^-?\d+(?:\.\d+)?$/;

export function decimalString(value: string): DecimalString {
  if (!DECIMAL_PATTERN.test(value)) {
    throw new Error(`дробная величина передаётся десятичной строкой, получено «${value}»`);
  }
  return value as DecimalString;
}

/**
 * Единый конверт ошибки сервера, зеркало server/app/core/errors.py.
 * Обязательные части — code и message; остальное сервер кладёт, когда есть что сказать.
 */
export interface ErrorEnvelope {
  /** Машинный код: по нему интерфейс решает, что делать. */
  code: string;
  /** Что произошло, словами человека без техобразования. */
  message: string;
  /** Почему так, с цифрами, если они есть. */
  hint?: string;
  /** Что сделать прямо сейчас, одно действие. */
  next_action?: string;
  /** Какие поля виноваты: форма подсвечивает их, а не показывает общий тост. */
  fields?: Record<string, string>;
  /** Служебные подробности, например request_id. */
  details?: Record<string, unknown>;
}

/** Форма любого спискового ответа: данные, сколько всего и на какой момент срез. */
export interface ListResponse<T> {
  items: T[];
  total: number;
  /** Момент среза на сервере. Показ «данные на 14:32» берёт время отсюда, не с часов клиента. */
  generated_at: string;
}
